import React from 'react'

const InfoBuildingType = () => {
    return (
        <div className='content-text'>
            Select a building type to begin customization. Buildings are categorized by utility and width to help you choose <span>the best fit for your specific needs.</span> However, you can customize all the building components on the next tabs.
        </div>
    )
}

export default InfoBuildingType